<div class="mm-page">
    <main class="mm-main">
  
      <!-- Header -->
      <header class="mm-topbar">
        <div>
          <h1>Motor Monitoring</h1>
          <p class="mm-subtitle">Trends and Analytics for your motors</p>
        </div>
        <div class="mm-top-actions">
          <div class="mm-updated">Last refreshed <strong>{{ lastUpdated | date:'dd MMM, HH:mm:ss' }}</strong></div>
          <button class="mm-icon-btn" title="Refresh data" aria-label="Refresh data" (click)="reloadAll()">↻</button>
        </div>
      </header>
  
      <!-- Toolbar -->
      <section class="mm-toolbar">
        <label class="mm-select">
          <span>Motor</span>
          <select [ngModel]="selectedDevice" (ngModelChange)="selectDevice($event)">
            <option value="all">All motors</option>
            <option *ngFor="let d of devices" [value]="deviceName(d)">{{ deviceName(d) }}</option>
          </select>
        </label>
        <button class="mm-btn mm-btn-dark" (click)="openHistory()">History &amp; report</button>
        <button class="mm-btn mm-btn-outline" (click)="openThresholds()">Set thresholds</button>
      </section>
  
      <div class="mm-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  
      <!-- KPIs -->
      <section class="mm-kpis">
        <article class="mm-kpi">
          <span class="mm-kpi-label">Motors monitored</span>
          <strong>{{ devices.length || latest.length || 0 }}</strong>
          <small>Devices with stored readings</small>
        </article>
        <article class="mm-kpi">
          <span class="mm-kpi-label">Open alerts</span>
          <strong [ngClass]="openAlerts.length ? 'mm-crit' : ''">{{ openAlerts.length }}</strong>
          <small>Threshold breaches not yet cleared</small>
        </article>
        <article class="mm-kpi">
          <span class="mm-kpi-label">Avg. temperature 1</span>
          <strong>{{ averageTemperature === null ? '—' : (averageTemperature | number:'1.1-1') }}<em
              *ngIf="averageTemperature !== null"> °C</em></strong>
          <small>Latest reading per motor</small>
        </article>
        <article class="mm-kpi">
          <!-- CHANGED 1: label only -->
          <span class="mm-kpi-label">Avg. vibration 1 (X)</span>
          <strong>{{ averageVibration === null ? '—' : (averageVibration | number:'1.2-2') }}</strong>
          <small>Latest reading per motor</small>
        </article>
        <article class="mm-kpi">
          <span class="mm-kpi-label">Readings in graph range</span>
          <strong>{{ graphReadings.length }}</strong>
          <small>{{ activeRangeLabel }}</small>
        </article>
      </section>
  
      <!-- Selected asset -->
      <section class="mm-panel mm-asset">
        <div class="mm-asset-head">
          <div>
            <h2>{{ latestReading ? latestReading.Deviceid : (selectedDevice === 'all' ? 'All motors' : selectedDevice) }}
              <span class="mm-tag">Motor</span>
              <span class="mm-status" *ngIf="latestReading" [class.on]="isOnline(latestReading)">{{
                isOnline(latestReading) ? 'Receiving data' : 'No data in last 30 min' }}</span>
            </h2>
            <p class="mm-muted" *ngIf="latestReading">Last device reading: {{ dateLabel(latestReading.reading_time) }} ({{
              timeAgo(latestReading.reading_time) }})</p>
            <p class="mm-muted" *ngIf="!latestReading">No readings found for this selection.</p>
          </div>
          <button class="mm-btn mm-btn-outline" *ngIf="latestReading" (click)="openDetails(latestReading)">View all
            values</button>
        </div>
  
        <!-- CHANGED 2a: the two Vibration cards were removed from here -->
        <div class="mm-params" *ngIf="latestReading">
          <div class="mm-param"><span>Temperature 1</span><strong
              [ngClass]="level(latestReading,'Temperature_Sensor_1')">{{ format(latestReading.Temperature_Sensor_1,1)
              }}<small> °C</small></strong></div>
          <div class="mm-param"><span>Temperature 2</span><strong
              [ngClass]="level(latestReading,'Temperature_Sensor_2')">{{ format(latestReading.Temperature_Sensor_2,1)
              }}<small> °C</small></strong></div>
          <div class="mm-param"><span>Frequency</span><strong [ngClass]="level(latestReading,'Frequency')">{{
              format(latestReading.Frequency) }}<small> Hz</small></strong></div>
          <div class="mm-param"><span>Active power</span><strong [ngClass]="level(latestReading,'Active_Power')">{{
              format(latestReading.Active_Power) }}</strong></div>
          <div class="mm-param"><span>Power factor</span><strong [ngClass]="level(latestReading,'Power_Factor')">{{
              format(latestReading.Power_Factor) }}</strong></div>
        </div>
  
        <div class="mm-groups" *ngIf="latestReading">
          <div class="mm-group">
            <h3>Voltage <small>V</small></h3>
            <div class="mm-chips">
              <span [ngClass]="level(latestReading,'Voltage_R')"><i>R</i>{{ format(latestReading.Voltage_R,1) }}</span>
              <span [ngClass]="level(latestReading,'Voltage_Y')"><i>Y</i>{{ format(latestReading.Voltage_Y,1) }}</span>
              <span [ngClass]="level(latestReading,'Voltage_B')"><i>B</i>{{ format(latestReading.Voltage_B,1) }}</span>
            </div>
          </div>
          <div class="mm-group">
            <h3>Current <small>A</small></h3>
            <div class="mm-chips">
              <span [ngClass]="level(latestReading,'Current_R')"><i>R</i>{{ format(latestReading.Current_R) }}</span>
              <span [ngClass]="level(latestReading,'Current_Y')"><i>Y</i>{{ format(latestReading.Current_Y) }}</span>
              <span [ngClass]="level(latestReading,'Current_B')"><i>B</i>{{ format(latestReading.Current_B) }}</span>
            </div>
          </div>
          <div class="mm-group">
            <h3>Vibration 1 <small>mm/s</small></h3>
            <div class="mm-chips">
              <span [ngClass]="level(latestReading,'Vibration_Velocity_X_1')"><i>X</i>{{
                format(latestReading.Vibration_Velocity_X_1) }}</span>
              <span [ngClass]="level(latestReading,'Vibration_Velocity_y_1')"><i>Y</i>{{
                format(latestReading.Vibration_Velocity_y_1) }}</span>
              <span [ngClass]="level(latestReading,'Vibration_Velocity_Z_1')"><i>Z</i>{{
                format(latestReading.Vibration_Velocity_Z_1) }}</span>
            </div>
          </div>
          <div class="mm-group">
            <h3>Vibration 2 <small>mm/s</small></h3>
            <div class="mm-chips">
              <span [ngClass]="level(latestReading,'Vibration_Velocity_X_2')"><i>X</i>{{
                format(latestReading.Vibration_Velocity_X_2) }}</span>
              <span [ngClass]="level(latestReading,'Vibration_Velocity_y_2')"><i>Y</i>{{
                format(latestReading.Vibration_Velocity_y_2) }}</span>
              <span [ngClass]="level(latestReading,'Vibration_Velocity_Z_2')"><i>Z</i>{{
                format(latestReading.Vibration_Velocity_Z_2) }}</span>
            </div>
          </div>
        </div>
      </section>
  
      <!-- Trend + analytics -->
      <section class="mm-grid-2">
        <article class="mm-panel mm-chart-panel">
          <div class="mm-panel-head">
            <h2>Parameter trend</h2>
            <select class="mm-mini-select" [ngModel]="selectedTrend" (ngModelChange)="changeTrend($event)"
              aria-label="Parameter">
              <option *ngFor="let option of trendOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
  
          <div class="mm-graph-bar">
            <div class="mm-range">
              <button *ngFor="let range of graphRanges" [class.selected]="graphRange===range.value"
                (click)="setGraphRange(range.value)">{{ range.label }}</button>
            </div>
            <div class="mm-custom" *ngIf="graphRange==='custom'">
              <input type="datetime-local" [(ngModel)]="graphFrom" aria-label="Graph start date">
              <span>to</span>
              <input type="datetime-local" [(ngModel)]="graphTo" aria-label="Graph end date">
              <button class="mm-btn mm-btn-dark mm-btn-sm" (click)="applyGraphRange()">Apply</button>
            </div>
          </div>
  
          <div class="mm-legend">
            <span *ngFor="let name of activeTrend.names; let i=index"><i [style.background]="activeTrend.colors[i]"></i>{{
              name }}</span>
            <small>Unit: {{ activeTrend.unit }} · {{ graphReadings.length }} readings</small>
          </div>
  
          <div class="mm-chart" *ngIf="chart">
            <svg #svgEl class="mm-svg" [attr.viewBox]="'0 0 ' + W + ' ' + H" role="img"
              aria-label="Parameter trend line chart">
              <defs>
                <linearGradient *ngFor="let s of chart.series; let i=index" [attr.id]="'mmGrad'+i" x1="0" y1="0" x2="0"
                  y2="1">
                  <stop offset="0%" [attr.stop-color]="s.color" stop-opacity="0.22"></stop>
                  <stop offset="100%" [attr.stop-color]="s.color" stop-opacity="0"></stop>
                </linearGradient>
              </defs>
  
              <g *ngFor="let t of chart.yTicks">
                <line class="mm-grid" [attr.x1]="chart.plot.l" [attr.x2]="chart.plot.r" [attr.y1]="t.y" [attr.y2]="t.y">
                </line>
                <text class="mm-axis" text-anchor="end" [attr.x]="chart.plot.l - 8" [attr.y]="t.y + 4">{{ t.label
                  }}</text>
              </g>
              <text *ngFor="let t of chart.xTicks" class="mm-axis" [attr.text-anchor]="t.anchor" [attr.x]="t.x"
                [attr.y]="chart.plot.b + 22">{{ t.label }}</text>
  
              <path *ngFor="let s of chart.series; let i=index" [attr.d]="s.area" [attr.fill]="'url(#mmGrad'+i+')'"
                [attr.opacity]="chart.series.length > 3 ? 0 : 1" stroke="none"></path>
              <path *ngFor="let s of chart.series" [attr.d]="s.line" fill="none" [attr.stroke]="s.color"
                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
  
              <g *ngFor="let s of chart.series">
                <circle *ngFor="let p of s.dots" [attr.cx]="p.x" [attr.cy]="p.y" r="3.5" fill="#fff"
                  [attr.stroke]="s.color" stroke-width="2"></circle>
              </g>
  
              <g *ngIf="hover">
                <line class="mm-cross" [attr.x1]="hover.x" [attr.x2]="hover.x" [attr.y1]="chart.plot.t"
                  [attr.y2]="chart.plot.b"></line>
                <circle *ngFor="let it of hover.items" [attr.cx]="hover.x" [attr.cy]="it.y" r="5" [attr.fill]="it.color"
                  stroke="#fff" stroke-width="2"></circle>
              </g>
  
              <rect class="mm-hit" [attr.x]="chart.plot.l" [attr.y]="chart.plot.t"
                [attr.width]="chart.plot.r - chart.plot.l" [attr.height]="chart.plot.b - chart.plot.t"
                (mousemove)="onChartMove($event, svgEl)" (mouseleave)="hover = null"></rect>
            </svg>
  
            <div class="mm-tip" *ngIf="hover" [class.flip]="hover.flip" [style.left.%]="hover.xPct">
              <strong>{{ hover.time }}</strong>
              <div *ngFor="let it of hover.items"><i [style.background]="it.color"></i>{{ it.name }}<b>{{ it.value }}</b>
              </div>
            </div>
          </div>
          <div class="mm-empty-chart" *ngIf="!chart">{{ loading ? 'Loading readings…' : 'No readings in this period. Try a
            longer range.' }}</div>
        </article>
  
        <article class="mm-panel">
          <div class="mm-panel-head">
            <h2>Range analytics</h2>
            <span class="mm-badge">{{ activeRangeLabel }}</span>
          </div>
          <div class="mm-table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th class="num">Min</th>
                  <th class="num">Max</th>
                  <th class="num">Avg</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let a of analytics">
                  <td>{{ a.label }}<small *ngIf="a.unit"> {{ a.unit }}</small></td>
                  <td class="num">{{ a.min }}</td>
                  <td class="num">{{ a.max }}</td>
                  <td class="num">{{ a.avg }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
      </section>
  
      <section class="mm-panel mm-history">
        <div class="mm-panel-head">
          <h2>Alerts <span class="mm-count">{{ openAlerts.length }} open · {{ alerts.length }} total</span></h2>
          <button class="mm-btn mm-btn-outline" [disabled]="!alerts.length" (click)="exportAlertsCsv()">Download alert
            report</button>
        </div>
        <div class="mm-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Device</th>
                <th>Time</th>
                <th>Parameter</th>
                <th class="num">Value</th>
                <th>Limit</th>
                <th>Severity</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of alerts | slice:0:10">
                <td><strong>{{ a.Deviceid }}</strong></td>
                <td>{{ dateLabel(a.reading_time) }}</td>
                <td>{{ paramLabel(a.parameter) }}</td>
                <td class="num"><b>{{ a.value }}</b></td>
                <td>{{ a.direction === 'high' ? '≥' : '≤' }} {{ a.threshold }}</td>
                <td><span class="mm-pill" [ngClass]="a.severity === 'critical' ? 'crit' : 'warn'">{{ a.severity }}</span>
                </td>
                <td><span class="mm-pill" [ngClass]="a.status">{{ a.status }}</span></td>
                <td class="num"><button class="mm-btn mm-btn-sm mm-btn-outline" *ngIf="a.status==='open'"
                    (click)="ackAlert(a)">Acknowledge</button></td>
              </tr>
              <tr *ngIf="!alerts.length">
                <td colspan="8" class="mm-empty-cell">No alerts. All readings are within limits.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
  
      <!-- Latest readings -->
      <section class="mm-panel mm-history">
        <div class="mm-panel-head">
          <h2>Latest readings <span class="mm-count">Showing {{ readings.length > 5 ? 5 : readings.length }} of {{
              readings.length }}</span></h2>
          <button class="mm-btn mm-btn-outline" (click)="openHistory()">Open report &amp; export</button>
        </div>
        <div class="mm-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Device</th>
                <th>Date &amp; time</th>
                <!-- CHANGED 3a: Vib. 1 / Vib. 2 headers -->
                <th>Vib. 1 X/Y/Z</th>
                <th>Vib. 2 X/Y/Z</th>
                <th class="num">Temp. 1</th>
                <th class="num">Temp. 2</th>
                <th>Voltage R/Y/B</th>
                <th>Current R/Y/B</th>
                <th class="num">Freq.</th>
                <th class="num">PF</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of readings | slice:0:5" (click)="openDetails(r)" class="mm-click-row">
                <td><strong>{{ r.Deviceid }}</strong></td>
                <td>{{ dateLabel(r.reading_time) }}</td>
                <!-- CHANGED 3b: Vib. 1 / Vib. 2 cells -->
                <td>{{ format(r.Vibration_Velocity_X_1) }} / {{ format(r.Vibration_Velocity_y_1) }} / {{
                  format(r.Vibration_Velocity_Z_1) }}</td>
                <td>{{ format(r.Vibration_Velocity_X_2) }} / {{ format(r.Vibration_Velocity_y_2) }} / {{
                  format(r.Vibration_Velocity_Z_2) }}</td>
                <td class="num">{{ format(r.Temperature_Sensor_1,1) }}</td>
                <td class="num">{{ format(r.Temperature_Sensor_2,1) }}</td>
                <td>{{ format(r.Voltage_R,0) }} / {{ format(r.Voltage_Y,0) }} / {{ format(r.Voltage_B,0) }}</td>
                <td>{{ format(r.Current_R,1) }} / {{ format(r.Current_Y,1) }} / {{ format(r.Current_B,1) }}</td>
                <td class="num">{{ format(r.Frequency,2) }}</td>
                <td class="num">{{ format(r.Power_Factor,2) }}</td>
              </tr>
              <tr *ngIf="!readings.length">
                <td colspan="10" class="mm-empty-cell">{{ loading ? 'Loading…' : 'No readings found for this selection.'
                  }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
  
      <footer class="mm-footer">
        <span>Motor Monitoring · Operations workspace</span>
        <span>Auto-refreshes every 30 seconds · <button (click)="reloadAll()">Refresh now</button></span>
      </footer>
    </main>
  
    <!-- Modals live in this host; the component moves it to <body> so it is always centred on the full screen -->
    <div #overlayHost class="mm-overlay-host">
  
      <div class="mm-backdrop" *ngIf="showDetails && detailReading" (click)="closeDetails()">
        <section class="mm-modal mm-modal-sm" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
          <div class="mm-modal-head">
            <div>
              <h2>{{ detailReading.Deviceid }}</h2>
              <p>Reading from {{ dateLabel(detailReading.reading_time) }}</p>
            </div>
            <button class="mm-close" aria-label="Close" (click)="closeDetails()">×</button>
          </div>
          <div class="mm-details">
            <!-- CHANGED 4: the two vibration lines -->
            <div><span>Vibration 1 X / Y / Z</span><strong>{{ format(detailReading.Vibration_Velocity_X_1) }} / {{
                format(detailReading.Vibration_Velocity_y_1) }} / {{ format(detailReading.Vibration_Velocity_Z_1)
                }}</strong></div>
            <div><span>Vibration 2 X / Y / Z</span><strong>{{ format(detailReading.Vibration_Velocity_X_2) }} / {{
                format(detailReading.Vibration_Velocity_y_2) }} / {{ format(detailReading.Vibration_Velocity_Z_2)
                }}</strong></div>
            <div><span>Temperature sensor 1</span><strong>{{ format(detailReading.Temperature_Sensor_1) }} °C</strong>
            </div>
            <div><span>Temperature sensor 2</span><strong>{{ format(detailReading.Temperature_Sensor_2) }} °C</strong>
            </div>
            <div><span>Voltage R / Y / B</span><strong>{{ format(detailReading.Voltage_R) }} / {{
                format(detailReading.Voltage_Y) }} / {{ format(detailReading.Voltage_B) }} V</strong></div>
            <div><span>Current R / Y / B</span><strong>{{ format(detailReading.Current_R) }} / {{
                format(detailReading.Current_Y) }} / {{ format(detailReading.Current_B) }} A</strong></div>
            <div><span>Frequency</span><strong>{{ format(detailReading.Frequency) }} Hz</strong></div>
            <div><span>Active power</span><strong>{{ format(detailReading.Active_Power) }}</strong></div>
            <div><span>Power factor</span><strong>{{ format(detailReading.Power_Factor) }}</strong></div>
            <div><span>Voltage THD R / Y / B</span><strong>{{ format(detailReading.Voltage_THD_R) }} / {{
                format(detailReading.Voltage_THD_Y) }} / {{ format(detailReading.Voltage_THD_B) }}</strong></div>
            <div><span>Current THD R / Y / B</span><strong>{{ format(detailReading.Current_THD_R) }} / {{
                format(detailReading.Current_THD_Y) }} / {{ format(detailReading.Current_THD_B) }}</strong></div>
            <div><span>Network / version</span><strong>{{ format(detailReading.Network,0) }} / {{
                format(detailReading.Version,0) }}</strong></div>
          </div>
          <div class="mm-modal-foot"><span>Values are shown exactly as received from the device.</span><button
              class="mm-btn mm-btn-dark" (click)="closeDetails()">Close</button></div>
        </section>
      </div>
  
      <div class="mm-backdrop" *ngIf="showThresholds" (click)="closeThresholds()">
        <section class="mm-modal mm-modal-lg" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
          <div class="mm-modal-head">
            <div>
              <h2>Alert thresholds</h2>
              <p>{{ selectedDevice === 'all' ? 'Default limits for all motors' : 'Limits for ' + selectedDevice + ' only
                (overrides the default)' }}</p>
            </div>
            <button class="mm-close" aria-label="Close" (click)="closeThresholds()">×</button>
          </div>
  
          <div class="mm-th-legend">
            <span><i class="crit"></i>Critical</span>
            <span><i class="warn"></i>Warning</span>
            <small>Alert triggers when a value is ≤ a low limit or ≥ a high limit. Leave a box empty to skip it.</small>
          </div>
  
          <div class="mm-table-wrap mm-modal-table">
            <table class="mm-th-table">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th class="num th-crit">Critical low</th>
                  <th class="num th-warn">Warning low</th>
                  <th class="num th-warn">Warning high</th>
                  <th class="num th-crit">Critical high</th>
                  <th class="num">Active</th>
                </tr>
              </thead>
              <tbody *ngFor="let g of thresholdGroups">
                <tr class="mm-th-group">
                  <td colspan="6">{{ g.title }}</td>
                </tr>
                <tr *ngFor="let p of g.items" [class.off]="thresholds[p.key].enabled === 0">
                  <td>{{ p.label }} <small *ngIf="p.unit">{{ p.unit }}</small></td>
                  <td class="num"><input type="number" step="any" placeholder="—"
                      [(ngModel)]="thresholds[p.key].crit_low"></td>
                  <td class="num"><input type="number" step="any" placeholder="—"
                      [(ngModel)]="thresholds[p.key].warn_low"></td>
                  <td class="num"><input type="number" step="any" placeholder="—"
                      [(ngModel)]="thresholds[p.key].warn_high"></td>
                  <td class="num"><input type="number" step="any" placeholder="—"
                      [(ngModel)]="thresholds[p.key].crit_high"></td>
                  <td class="num">
                    <label class="mm-switch">
                      <input type="checkbox" #cb [checked]="thresholds[p.key].enabled !== 0"
                        (change)="thresholds[p.key].enabled = cb.checked ? 1 : 0">
                      <span></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="mm-modal-foot">
            <span>New readings are checked against these limits automatically.</span>
            <span class="mm-foot-actions">
              <button class="mm-btn mm-btn-outline" (click)="closeThresholds()">Cancel</button>
              <button class="mm-btn mm-btn-dark" (click)="saveThresholds()">Save thresholds</button>
            </span>
          </div>
        </section>
      </div>
  
      <div class="mm-backdrop" *ngIf="showHistory" (click)="closeHistory()">
        <section class="mm-modal mm-modal-lg" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
          <div class="mm-modal-head">
            <div>
              <h2>Motor readings history</h2>
              <p>{{ selectedDeviceLabel }} · {{ reportReadings.length }} records between {{ dateLabel(reportFrom, false)
                }} and {{ dateLabel(reportTo, false) }}</p>
            </div>
            <button class="mm-close" aria-label="Close" (click)="closeHistory()">×</button>
          </div>
  
          <div class="mm-report-filters">
            <div class="mm-range">
              <button *ngFor="let range of reportRanges" [class.selected]="reportRange===range.value"
                (click)="setReportRange(range.value)">{{ range.label }}</button>
            </div>
            <div class="mm-custom" *ngIf="reportRange==='custom'">
              <input type="datetime-local" [(ngModel)]="reportFrom" aria-label="Report start date">
              <span>to</span>
              <input type="datetime-local" [(ngModel)]="reportTo" aria-label="Report end date">
              <button class="mm-btn mm-btn-dark mm-btn-sm" (click)="applyReportRange()">Apply</button>
            </div>
            <button class="mm-btn mm-btn-accent mm-push" [disabled]="!reportReadings.length"
              (click)="exportHistoryCsv()">Download CSV (Excel)</button>
          </div>
  
          <div class="mm-table-wrap mm-modal-table">
            <table>
              <thead>
                <tr>
                  <th>Device</th>
                  <th>Date &amp; time</th>
                  <!-- CHANGED 5a: Vib. 1 / Vib. 2 headers -->
                  <th>Vib. 1 X/Y/Z</th>
                  <th>Vib. 2 X/Y/Z</th>
                  <th class="num">Temp. 1</th>
                  <th class="num">Temp. 2</th>
                  <th>Voltage R/Y/B</th>
                  <th>Current R/Y/B</th>
                  <th class="num">Freq.</th>
                  <th class="num">Power</th>
                  <th class="num">PF</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of reportReadings">
                  <td>{{ r.Deviceid }}</td>
                  <td>{{ dateLabel(r.reading_time) }}</td>
                  <!-- CHANGED 5b: Vib. 1 / Vib. 2 cells -->
                  <td>{{ format(r.Vibration_Velocity_X_1) }} / {{ format(r.Vibration_Velocity_y_1) }} / {{
                    format(r.Vibration_Velocity_Z_1) }}</td>
                  <td>{{ format(r.Vibration_Velocity_X_2) }} / {{ format(r.Vibration_Velocity_y_2) }} / {{
                    format(r.Vibration_Velocity_Z_2) }}</td>
                  <td class="num">{{ format(r.Temperature_Sensor_1,1) }}</td>
                  <td class="num">{{ format(r.Temperature_Sensor_2,1) }}</td>
                  <td>{{ format(r.Voltage_R,0) }} / {{ format(r.Voltage_Y,0) }} / {{ format(r.Voltage_B,0) }}</td>
                  <td>{{ format(r.Current_R) }} / {{ format(r.Current_Y) }} / {{ format(r.Current_B) }}</td>
                  <td class="num">{{ format(r.Frequency) }}</td>
                  <td class="num">{{ format(r.Active_Power) }}</td>
                  <td class="num">{{ format(r.Power_Factor) }}</td>
                </tr>
                <tr *ngIf="!reportReadings.length">
                  <td colspan="11" class="mm-empty-cell">{{ reportLoading ? 'Loading history…' : 'No readings in this
                    period. Choose a longer range.' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mm-modal-foot"><span>The CSV opens directly in Microsoft Excel.</span><button
              class="mm-btn mm-btn-outline" (click)="closeHistory()">Close</button></div>
        </section>
      </div>
  
    </div>
  </div>